module.exports = __webpack_public_path__ + "static/images/ring.3894b57.png";